// extracted by mini-css-extract-plugin
module.exports = {"card_dummy":"card_dummy-1ka2K","footer":"footer-3sTyR"};